import React, { useState } from "react";

import { Button, MenuItem, Modal, Stack, StackOwnProps, TextField } from "@mui/material";
import { SimpleHeadMui } from "components";
import { useDidUpdate } from "hooks";
import { startCase } from "lodash";
import { useDealStatusesSelector } from "store";
import { CreateDealStageData } from "store/types";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: CreateDealStageData) => Promise<void>;
}

export const CreatePipeline: React.FC<Props> = ({ isOpen, onClose, onSubmit }) => {
  const statuses = useDealStatusesSelector().filter((option) => option.name !== "Altius Opportunity");

  const [title, setTitle] = useState<string>("");
  const [statusId, setStatusId] = useState<number | null>(null);

  useDidUpdate(() => {
    if (isOpen) return;
    setTitle("");
    setStatusId(null);
  }, [isOpen]);

  return (
    <Modal onClose={onClose} open={isOpen}>
      <Stack sx={style}>
        <SimpleHeadMui containerProps={{ sx: { borderRadius: "12px 12px 0 0" } }} onIconClick={onClose}>
          Create Column
        </SimpleHeadMui>
        <Stack sx={{ gap: "20px", p: "20px", mb: "40px" }}>
          <TextField value={title} onChange={(e) => setTitle(e.target.value)} label="Column Name" />
          <TextField
            value={statusId}
            onChange={(e) => setStatusId(e.target.value as unknown as number)}
            select
            label="Status"
          >
            {statuses.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {startCase(option.name)}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
        <Stack
          direction="row"
          sx={{ justifyContent: "flex-end", gap: "20px", p: "20px", borderTop: "1px solid #dae0e2" }}
        >
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (!title || !statusId) return;
              onSubmit({ title, status_id: statusId });
              onClose();
            }}
            disabled={!title || !statusId}
            variant="contained"
          >
            Submit
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

const style: StackOwnProps["sx"] = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "400px",
  bgcolor: "white",
  borderRadius: "12px"
};
